import { observer } from 'mobx-react-lite';
import React from 'react'
import { useEffect } from 'react';
import { useStore } from '../../../../../../hooks/useStore'
import { getContentfulImageURL } from '../../../../../../utils/general';
import { PillButton } from '../../../../../general/buttons/pill-button'


const getShareCardImages = (locationData) => {
    const {orgsAtlanta, orgsChicago, orgsDetroit, orgsLA, orgsPhiladelphia, orgsBuffalo} = locationData;
    const images = [
        getContentfulImageURL(orgsAtlanta.edges[0].node.shareCardImage?.file.url, 1400, 90),
        getContentfulImageURL(orgsChicago.edges[0].node.shareCardImage?.file.url, 1400, 90),
        getContentfulImageURL(orgsDetroit.edges[0].node.shareCardImage?.file.url,1400, 90),
        getContentfulImageURL(orgsLA.edges[0].node.shareCardImage?.file.url,1400, 90),
        getContentfulImageURL(orgsPhiladelphia.edges[0].node.shareCardImage?.file.url,1400, 90),
        getContentfulImageURL(orgsBuffalo.edges[0].node.shareCardImage?.file.url,1400, 90)
    ];

    return images;
}
const ActivationPlaceholder = observer((props) => {
    const {uiStore: {activateShareSection, updateShareActivePreviewIndex, home__share__activePreviewIndex}} = useStore();
    const images = getShareCardImages(props.locationData);

    useEffect(() => {
        const interval = setInterval(updateShareActivePreviewIndex, 1200);
        return () => clearInterval(interval);
    }, []);


    return (
        <div className='activation-placeholder'>
            <div className="image-section flex--center">
                {images.map((image, index) => {
                    return <img className={index === home__share__activePreviewIndex ? "active" : ""} key={`sh-pr` + index} src={image} alt="" />
                })}
            </div>

            <div className="btn-section flex--center">
                <PillButton onClick={activateShareSection}>Start</PillButton>
            </div>

            <style jsx>{`
                img {
                    width: 800px;
                }

                .image-section {
                    height: 418px;
                    width: 800px;
                    contain: strict;
                    margin: 0 auto;
                }

                img {
                    position: absolute;
                    opacity: 0;
                    transition: opacity 0.3s;
                }

                .active {
                    z-index: 2;
                    opacity: 1;
                }

                .btn-section {
                    padding: 20px 0;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .image-section {
                        padding: 0 30px;
                        position: relative;
                        height: 0;
                        padding-bottom: 56.25%;
                        width: 100%;
                        contain: initial;
                    }
                    img {
                        top: 0;
                        left: 30px;
                        width: calc(100% - 60px);
                    }
                }
            `}</style>
        </div>
    )
})



export default ActivationPlaceholder